// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { gql } from "@apollo/client";

export default gql`
  query patientDataQuery {
    patient: _patient {
      organization: _patient_managingorganization {
        _organization_alias {
          alias: organization_alias
          id: organization_id
        }
      }
      cpf: _patient_identifier(
        where: {
          patient_identifier_system: {
            _eq: "http://rnds.saude.gov.br/fhir/r4/NamingSystem/cpf"
          }
        }
      ) {
        value: patient_identifier_value
      }
      telecom: _patient_telecom(
        where: {
          _patient_telecom_period: {
            patient_telecom_period_end: { _is_null: true }
          }
        }
      ) {
        system: patient_telecom_system
        value: patient_telecom_value
      }
      name: _patient_name(
        where: {
          _patient_name_period: { patient_name_period_end: { _is_null: true } }
        }
      ) {
        _patient_name_given {
          given: patient_name_given
        }
        family: patient_name_family
      }
      gender: patient_gender
      birthdate: patient_birthdate
      address: _patient_address(
        where: {
          _patient_address_period: {
            patient_address_period_end: { _is_null: true }
          }
        }
      ) {
        city: patient_address_city
        cep: patient_address_postalcode
        state: patient_address_state
      }
    }
    _healthstatus(limit: 1) {
      observation_id
    }
    _consent_policy {
      consent_policy_uri
    }
  }
`;
